module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-12.54a2a9da.png";